export default "__VITE_ASSET__6a55d125__"